/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const iconSizes = {
  '2xl': 24,
  '2xs': 12,
  lg: 20,
  md: 18,
  sm: 16,
  xl: 22,
  xs: 14,
} as const;
